import React from "react";
import s from "./style.module.scss";
import { StarRatingValue } from "../StarRatingValue";
import { ApprovedIcon } from "../Icons/Approved";
import glideImage from "../../utils/useGlideImage.ts";

type TestimonialCardProps = {
  image: string;
  name: string;
  country: string;
  tr_description: string;
  stars_rating: string;
};

const TestimonialCard = ({
  card,
  verifiedBuyerLabel,
}: {
  card: TestimonialCardProps;
  verifiedBuyerLabel?: string;
}) => {
  return (
    <div className={s.testimonialsCard}>
      <img
        src={glideImage(card.image, { w: 330, h: 336 })}
        alt={card.name}
        width={330}
        height={336}
        loading="lazy"
      />
      <div className={s.testimonialsCard__ratingRow}>
        <StarRatingValue rating={card.stars_rating || "4.5"} />
        <div className={s.testimonialsCard__verified}>
          <ApprovedIcon />
          <p>{verifiedBuyerLabel}</p>
        </div>
      </div>
      <p
        className={s.testimonialsCard__name}
      >{`${card.name}, ${card.country}`}</p>
      <p
        className={s.testimonialsCard__text}
        dangerouslySetInnerHTML={{ __html: card.tr_description }}
      />
    </div>
  );
};

export default TestimonialCard;
